import { render, staticRenderFns } from "./project_team.vue?vue&type=template&id=5419b4c4&scoped=true"
import script from "./project_team.vue?vue&type=script&lang=js"
export * from "./project_team.vue?vue&type=script&lang=js"
import style0 from "./project_team.vue?vue&type=style&index=0&id=5419b4c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5419b4c4",
  null
  
)

export default component.exports